import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Link, useNavigate } from 'react-router-dom';
import styles from '../styles/Products.module.css';

const Products = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
   fetch('https://crmesquita.com.br/api/produtos/')
      .then((response) => response.json())
      .then((data) => {
        setProducts(data);
      })
      .catch((error) => console.error('Erro ao buscar produtos:', error));
  }, []);

  const handleBuy = (id) => {
    navigate(`/produto/${id}`);
  };

  const formatarPreco = (preco) => {
    const precoFloat = parseFloat(preco);
    if (isNaN(precoFloat)) return 'Preço inválido';

    return precoFloat.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
  };

  return (
    <div className={styles['max-container']}>
      <section className={styles['products-section']}>
        <h2 className={styles['products-title']}>Novidades</h2>

        {/* Botões de navegação personalizados */}
        <div className="swiper-button-prev custom-prev"></div>
        <div className="swiper-button-next custom-next"></div>

        <Swiper
          modules={[Navigation]}
          navigation={{
            prevEl: '.custom-prev',
            nextEl: '.custom-next',
          }}
          spaceBetween={20} // Espaçamento entre os slides
          loop={true}
          breakpoints={{
            320: {
              slidesPerView: 1, // 1 item para telas pequenas (ex.: celulares)
            },
            480: {
              slidesPerView: 2, // 2 itens para telas um pouco maiores
            },
            768: {
              slidesPerView: 3, // 3 itens para tablets
            },
            1024: {
              slidesPerView: 4, // 4 itens para laptops
            },
            1440: {
              slidesPerView: 5, // 5 itens para desktops grandes
            },
          }}
        >
          {products.slice(-7).map((product) => (
            <SwiperSlide key={product.id}>
              <div className={styles['product-card']}>
                <Link to={`/produto/${product.id}`} className={styles['product-link']}>
                  {product.marca.imagem ? (
                    <img
                      src={product.marca.imagem}
                      alt={product.marca.nome}
                      className={styles['product-image']}
                    />
                  ) : (
                    <div className={styles['product-placeholder']}>Sem imagem</div>
                  )}
                  <h3 className={styles['product-name']}>
                    {product.marca?.nome} |{' '}
                    {product.nome.replace(/trifasico/gi, 'trifásico').length > 42
                      ? product.nome.replace(/trifasico/gi, 'trifásico').slice(0, 42) + '...'
                      : product.nome.replace(/trifasico/gi, 'trifásico')}
                  </h3>
                  <p className={styles['product-price']}>{formatarPreco(product.preco)}</p>
                </Link>
                <div className={styles['product-actions']}>
                  <button
                    className={styles['buy-button']}
                    onClick={() => handleBuy(product.id)}
                  >
                    Comprar
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </div>
  );
};

export default Products;